import type { SubscriptionAnalyticsBreakdownItem } from "@/types/subscription";
import { Plan } from "@/types/enums";

const PAID_PLANS: ReadonlySet<Plan> = new Set([
  Plan.PLUS,
  Plan.PRO,
  Plan.PREMIUM,
]);

export function isPaidPlan(plan: Plan): boolean {
  return PAID_PLANS.has(plan);
}

export function countActivePaidSubscribers(
  breakdown: SubscriptionAnalyticsBreakdownItem[]
): number {
  return breakdown
    .filter((row) => isPaidPlan(row.plan))
    .reduce((acc, row) => acc + row.count, 0);
}

export function countAllSubscribers(
  breakdown: SubscriptionAnalyticsBreakdownItem[]
): number {
  return breakdown.reduce((acc, row) => acc + row.count, 0);
}

export function formatKrw(value: number): string {
  return `${Math.round(value).toLocaleString()}원`;
}

export function formatKrwCompact(value: number): string {
  const rounded = Math.round(value);
  if (rounded >= 100_000_000) {
    return `${(rounded / 100_000_000).toFixed(2)}억원`;
  }
  if (rounded >= 10_000) {
    return `${(rounded / 10_000).toFixed(1)}만원`;
  }
  return `${rounded.toLocaleString()}원`;
}
